<template>
  <v-toolbar flat>
    <v-toolbar-title class="headline primary--text font-weight-medium">
      <v-icon class="primary--text" left> {{ icon }} </v-icon>
      {{ title }}
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>
